const e=t=>({defaultProps:{slotProps:{popper:{sx:{".MuiMultiSectionDigitalClockSection-item.Mui-selected":{color:(t.vars||t).palette.primary.buttonContrastText}}}}}});export{e as default};
